import React from 'react';
import { Group, Rating, Text } from '@mantine/core';
import InspectorRow from '../../../puck/fields/InspectorRow';
import { INFO_CARD_LABELS } from '../../../../shared/boxes/infoCard/infoCardLabels';

/**
 * Note sur 5 de la carte. `0` = aucune note, et rien n'est rendu sur le site :
 * recliquer l'étoile déjà sélectionnée remet à 0 (comportement natif de
 * Rating), et le libellé le rappelle.
 */
export default function InfoCardRatingField({ value, onChange }) {
  const stars = Math.max(0, Math.min(5, Math.round(Number(value) || 0)));
  return (
    <InspectorRow label={INFO_CARD_LABELS.rating}>
      <Group gap="xs" align="center" wrap="nowrap">
        <Rating value={stars} count={5} onChange={onChange} />
        <Text size="xs" c="dimmed">
          {stars === 0 ? 'Aucune' : `${stars} / 5`}
        </Text>
      </Group>
    </InspectorRow>
  );
}
